import React, {useEffect, useState} from 'react';

import {getResourceTypes} from '../DropdownDataProviders' ;
import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";
import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownResourceTypes = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getResourceTypes(false).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownResourceTypes;

DropdownResourceTypes.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownResourceTypes.propTypes = {
    onChange: PropTypes.func.isRequired
};